import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { F, Sel, inputCls, btnPrimary, btnGhost, LEVELS } from "@/components/admin/ui";
import { PhoneInput } from "@/components/PhoneInput";

export function StudentForm({ initial, codes, defaultCode, onSaved, onCancel }) {
  const editing = Boolean(initial);
  const [f, setF] = useState({
    name: initial?.name || "", email: initial?.email || "", password: "",
    institution_code: initial?.institution_code || defaultCode || codes[0]?.code || "", target_level: initial?.target_level || "N4",
    phone_country: initial?.phone?.country || "+62", phone_number: initial?.phone?.number || "",
  });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e?.target ? e.target.value : e }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const payload = { ...f, phone_number: f.phone_number || null };
      if (editing) {
        if (!payload.password) delete payload.password;
        if (!f.phone_number && initial?.phone) payload.clear_phone = true;
        await api.put(`/admin/students/${initial.id}`, payload);
        toast.success("Data siswa diperbarui");
      } else {
        await api.post("/admin/students", payload);
        toast.success("Siswa ditambahkan");
      }
      onSaved?.();
    } catch (ex) { toast.error(errMsg(ex)); } finally { setBusy(false); }
  };

  return (
    <form onSubmit={submit} className="soft-card space-y-4 p-5" data-testid="student-form">
      <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-primary">{editing ? `Edit siswa · ${initial.name}` : "Tambah siswa"}</p>
      <div className="grid gap-3 sm:grid-cols-6">
        <F label="Nama lengkap" className="sm:col-span-3"><input data-testid="student-name-input" required className={inputCls} value={f.name} onChange={set("name")} /></F>
        <F label="Email" className="sm:col-span-3"><input data-testid="student-email-input" type="email" required className={inputCls} value={f.email} onChange={set("email")} /></F>
        <F label={editing ? "Password baru (kosongkan jika tetap)" : "Password awal (min. 8)"} className="sm:col-span-3"><input data-testid="student-password-input" type="text" minLength={8} required={!editing} className={inputCls} value={f.password} onChange={set("password")} placeholder={editing ? "••••••••" : "Minimal 8 karakter"} /></F>
        <F label="Kode lembaga" className="sm:col-span-2"><Sel testid="student-code-select" value={f.institution_code} onChange={set("institution_code")} options={codes.map((c) => c.code)} /></F>
        <F label="Target level" className="sm:col-span-1"><Sel testid="student-level-select" value={f.target_level} onChange={set("target_level")} options={LEVELS} /></F>
        <div className="sm:col-span-3"><PhoneInput testid="student-phone" country={f.phone_country} number={f.phone_number} onChange={({ country, number }) => setF((s) => ({ ...s, phone_country: country, phone_number: number }))} /></div>
      </div>
      <div className="flex gap-2">
        <button data-testid="student-save-button" disabled={busy} className={btnPrimary}>{editing ? "Simpan perubahan" : "Tambah siswa"}</button>
        <button type="button" data-testid="student-cancel-button" onClick={onCancel} className={btnGhost}>Batal</button>
      </div>
    </form>
  );
}
